// src/api/executive/account.api.tsx
import BaseAPI from 'api/api'
import type {
  AccountFlowResponse,
  AdvanceResponse,
  BalanceResponse,
  ExpenseCategoryResponse,
  FinancialSummaryResponse,
  GetAccountFlowParams,
  GetExpenseCategoryParams,
  GetFinancialSummaryParams,
  GetTreatmentRevenueParams,
  TreatmentRevenueResponse,
} from './executive.types'

const path = 'executive/account'

export default class AccountApi extends BaseAPI {
  static async getBalance(params: GetAccountFlowParams): Promise<BalanceResponse> {
    const res = await BaseAPI.api.get(`${path}/balance`, { params })
    return res.data
  }

  static async getAdvance(params: GetAccountFlowParams): Promise<AdvanceResponse> {
    const res = await BaseAPI.api.get(`${path}/advance`, { params })
    return res.data
  }

  static async getWallet(params: GetAccountFlowParams): Promise<AccountFlowResponse> {
    const res = await BaseAPI.api.get(`${path}/wallet`, { params })
    return res.data
  }

  static async getFinancialSummary(
    params: GetFinancialSummaryParams
  ): Promise<FinancialSummaryResponse> {
    const res = await BaseAPI.api.get(`${path}/financial-summary`, { params })
    return res.data
  }

  static async getExpenseCategory(
    params: GetExpenseCategoryParams
  ): Promise<ExpenseCategoryResponse> {
    const res = await BaseAPI.api.get(`${path}/expense-category`, { params })
    return res.data
  }

  static async getTreatmentRevenue(
    params: GetTreatmentRevenueParams
  ): Promise<TreatmentRevenueResponse> {
    const res = await BaseAPI.api.get(`${path}/treatment-revenue`, { params })
    return res.data
  }
}
